/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusFavoritenListeDto } from '../../models/lexplus-favoriten-liste-dto';

export interface FavoritenControllerFindAllV1$Params {
  limit?: number;
  offset?: number;
}

export function favoritenControllerFindAllV1(http: HttpClient, rootUrl: string, params?: FavoritenControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusFavoritenListeDto>> {
  const rb = new RequestBuilder(rootUrl, favoritenControllerFindAllV1.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusFavoritenListeDto>;
    })
  );
}

favoritenControllerFindAllV1.PATH = '/v1/favoriten';
